const routeParams = {
    events: {
        city: 'city',
        event: 'evento',
        latitude: 'lat',
        longitude: 'long',
        term: 'term',
        date: 'filter_date',
        type: 'classification_id',
        tags: 'tags',
        range: 'distance_range',
        minDate: 'min_date',
        maxDate: 'max_date',
        scroll: 'scrollTo'
    },
    establishments: {
        city: 'city',
        establishment: 'estabelecimento',
        latitude: 'lat',
        longitude: 'long',
        term: 'term',
        date: 'filter_date',
        type: 'classification_id',
        tags: 'tags',
        feature: 'features',
        range: 'distance_range',
        minDate: 'min_date',
        maxDate: 'max_date',
        services: 'services'
    },

    permissions: {
        invitePermission: 'permission_invite',
        invitePermissionEvent: 'invite_permission_event'
    },

    teams: {
        invite: 'team_invite',
        inviteTeamName: 'team_name',
        inviteProducer: 'team_producer'
    },

    resume: {
        create: 'create',
        detail: 'detail',
        // Abre MainContent.js já em modo edição, direto no step de produtos
        // (valor = slug do evento) — usado pela aba "A venda em eventos" da
        // página de Produtos pra levar o produtor pro assistente do evento.
        editProducts: 'edit-products',
        highlightProduct: 'highlight-product'
    },
    products: {
        create: 'create',
    },
    profile: {
        create: 'create'
    },
    partner: {
        create: 'createPartner'
    },
    financial: {
        bank: 'dados-bancarios',
        invoices: 'notas-fiscais',
        calendar: 'agenda-de-recebiveis'
    },
    payments: {
        checkout: 'checkout', 
        hiddenCode: 'hidden_code'
    }
};

export default routeParams;